/* eslint-disable object-property-newline */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useTranslation, withTranslation } from "react-i18next";
import PreviewPDF from "./PreviewPDF.js";
import GeneratePDF from "./GeneratePDF.js";
import { signOnDocuments } from "./signOnDocuments.js";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
import { connect, useDispatch } from "react-redux";
import { fetchClientDetails } from "../../../store/client/actions.js";

function KuwaitDocuments(props) {
  const { t } = useTranslation();
  const [signedUrls, setSignedUrls] = useState([]);
  const kuwaitDocument = ["Kuwait_KYC_1", "Kuwait_KYC_2"];
  const { clientId } = useParams();
  const [clientData] = useState(props.clientDetails);
  const dispatch = useDispatch();
  console.log(clientData, "clientData");
  const handleSignedUrl = async fileName => {
    const signedFile = await signOnDocuments(
      fileName,
      `${clientData?.firstName} ${clientData?.lastName}`
    );
    const blobUrl = URL.createObjectURL(signedFile);
    return blobUrl;
  };
  useEffect(() => {
    getClientDetails(clientId);
  }, [clientId]);

  const getClientDetails = async clientId => {
    dispatch(fetchClientDetails(clientId));
  };
  useEffect(() => {
    // if (!"mina mohamed"|| !"Kuwait_KYC_1") return;

    const getSignedUrls = async () => {
      const signedUrls = await Promise.all(kuwaitDocument.map(handleSignedUrl));
      setSignedUrls(signedUrls);
    };

    getSignedUrls();
  }, [clientData]);
  const kuwaitApplications = [
    {
      title: t("Civil ID Requirements"),
      fileUrl: signedUrls[0],
    },
    {
      title: t("Address Proof Guidelines"),
      fileUrl: signedUrls[1],
    },
  ];
  return (
    <div className="container mt-4">
      <h4 className="mb-4">{t("Kuwait Documents")}</h4>
      {kuwaitApplications.map((app, index) => (
        <div
          key={index}
          className="mt-3 pb-3 d-flex border-bottom justify-content-between align-items-center"
        >
          <span className="me-auto">{app.title}</span>
          <PreviewPDF
            heading={app.title}
            isIb={app.isIb}
            t={t}
            fileUrl={app.fileUrl}
          />
          <GeneratePDF
            heading={app.title}
            isIb={app.isIb}
            t={t}
            fileUrl={app.fileUrl}
          />
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = state => ({
  clientDetails: state.clientReducer.clientDetails,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(KuwaitDocuments));
